'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { memo } from 'react';

import NextImage from 'next/image';
import PropTypes from 'prop-types';

import ContentfulImg from 'components/globals/ContentfulImg';

import { addProtocol } from 'utils/url';

const GENERIC_ALT_PATTERNS =
    /^(image|photo|picture|untitled|placeholder|img|spacer)$/i;
const URL_ALT_PATTERNS = /^(https?:)?\/\//i;
const FILE_NAME_ALT_PATTERNS = /\.(gif|jpe?g|png|svg|webp)$/i;

const sanitizeAlt = alt => {
    const value = `${alt ?? ''}`.trim();

    if (
        GENERIC_ALT_PATTERNS.test(value) ||
        URL_ALT_PATTERNS.test(value) ||
        FILE_NAME_ALT_PATTERNS.test(value)
    ) {
        return '';
    }

    return value;
};

const Img = ({
    alt,
    className,
    customSources,
    fallbackImageWidth,
    height,
    loading,
    priority,
    sizes,
    src,
    width,
    ...rest
}) => {
    // Strip placeholder alt text that provides no value to screen readers.
    alt = sanitizeAlt(alt);
    fallbackImageWidth ??= 1280;
    loading ??= 'lazy';
    priority ??= false;
    sizes ??= '100vw';
    src ??= '';

    if (src.includes('downloads.ctfassets.net')) {
        console.error(
            `This following image is over 20mg and bypassing Contentful's Image API.: \n ${src} \n`
        );
        return null;
    }

    if (src.includes('images.ctfassets.net')) {
        return (
            <ContentfulImg
                alt={alt}
                className={className}
                customSources={customSources}
                fallbackImageWidth={fallbackImageWidth}
                loading={loading}
                priority={priority}
                src={src}
                height={height}
                width={width}
                {...rest}
            />
        );
    }

    return (
        <NextImage
            className={className}
            src={addProtocol(src)}
            alt={alt}
            height={height}
            width={width}
            sizes={sizes}
            loading={priority ? 'eager' : 'lazy'}
            fetchPriority={priority ? 'high' : 'low'}
            priority={priority}
            {...rest}
        />
    );
};

Img.propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string,
    customSources: PropTypes.array,
    draggable: PropTypes.bool,
    fallbackImageWidth: PropTypes.number,
    height: PropTypes.number,
    loading: PropTypes.oneOf(['eager', 'lazy']),
    priority: PropTypes.bool,
    src: PropTypes.string.isRequired,
    sizes: PropTypes.string,
    width: PropTypes.number,
};

export default memo(Img);
